import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import HandleFormData from '~/utils/HandleFormData';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import ColoredFileInput from '~/componentes/CustomForm/FileInput/styles/ColoredFileInput';

import { Container } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import RecursosList from './RecursosList';
import PrioridadeListColor from './PrioridadeListColor';
import AtividadesList from './AtividadesList';

function CreateEditContent({ mountedData }) {
  const [etapas, setEtapas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [prioridade, setPrioridade] = useState({});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapa : 1);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [ultimaEtapa, setUltimaEtapa] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');

  useEffect(() => {
    if (mountedData) {
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', { params: { ativo: 1, tipo: 'ORC' } })
        .then(r => {
          setEtapas(r?.data);
          setIdEtapa(mountedData?.idEtapa);
        });
    } else {
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', {
          params: { ativo: 1, tipo: 'ORC', posicao: 1 },
        })
        .then(r => {
          setEtapas(r?.data);
          if (r?.data?.length > 0) {
            setIdEtapa(r?.data[0]?.id);
          }
        });
    }

    api
      .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
      .then(r => setClientes(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/coordenadores', { params: { ativo: 1 } })
      .then(r => setCoordenadores(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/produtos', { params: { ativo: 1 } })
      .then(r => setProdutos(r?.data));

    setUltimaEtapa(mountedData?.etapa?.final == 'S' ? true : false);
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id &&
        api
          .get('/signed/empresa/gestorprojeto/gerencia/clientesolicitantes', {
            params: { ativo: 1, idCliente: cliente?.id },
          })
          .then(r => setSolicitantes(r?.data));
      cliente?.id &&
        api
          .get('/signed/empresa/gestorprojeto/projetos', {
            params: { ativo: 1, idCliente: cliente?.id },
          })
          .then(r => setProjetos(r?.data));
    } else {
      setSolicitantes([]);
      setProjetos([]);
    }
  }, [cliente]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData([file1, file2, file3, file4], {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          gerarProjeto,
          recursos,
          idEtapa,
          horaTotal,
          prioridade,
          atividades,
          removeArquivos,
        });

        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/orcamento', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/orcamento', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Orçamento, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Orçamento?`,
        successModal: `Orçamento ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true} noValidate>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        {!mountedData ? (
          <div className="row">
            <div className="col s12 m12 l12 no-padding">
              <div className="row no-margin">
                <Label title="Título *" className="col s5 m5 l5">
                  <Input name="titulo" required="true" defaultValue={mountedData?.titulo} />
                </Label>
                <Label title="Associação" className="col s3 m3 l3">
                  <Input name="associacao" defaultValue={mountedData?.associacao} />
                </Label>
                <Label title="Data Solicitação *" className="col s2 m2 l2">
                  <Input
                    type="date"
                    name="dataSolicitacao"
                    required="true"
                    defaultValue={mountedData?.dataSolicitacao}
                  />
                </Label>
                <Label title="Ativo *" className="col s2 m2 l2">
                  <Select
                    required="true"
                    isString
                    list={{
                      list: [
                        { id: 'true', titulo: 'Sim' },
                        { id: 'false', titulo: 'Não' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="ativo"
                    defaultValue={mountedData?.ativo?.toString()}
                    onChange={e => {
                      const v = e.currentTarget.value || 'true';
                      setAtivo(v);
                    }}
                  />
                </Label>
              </div>
              <div className="row no-margin">
                <Label title="Cliente *" className="col s6 m6 l3">
                  <Select
                    required="true"
                    isString
                    list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                    name="idCliente"
                    firstOption
                    defaultValue={mountedData?.idCliente}
                    onChange={e => {
                      const v = e.currentTarget.value || 'true';
                      const cliente = clientes?.find(e => e?.id == parseInt(v));
                      setCliente(cliente || {});
                    }}
                  />
                </Label>
                <Label title="Solicitante Cliente *" className="col s6 m3 l3">
                  <Select
                    required="true"
                    isString
                    list={{ list: solicitantes, value: 'id', label: 'nome' }}
                    name="idClienteSolicitante"
                    firstOption
                    defaultValue={mountedData?.idClienteSolicitante}
                  />
                </Label>
                <Label title="Produto *" className="col s6 m3 l2">
                  <Select
                    required="true"
                    isString
                    list={{ list: produtos, value: 'id', label: 'titulo' }}
                    name="idProduto"
                    firstOption
                    defaultValue={mountedData?.idProduto}
                  />
                </Label>
                <Label title="Gerente *" className="col s6 m3 l2">
                  <Select
                    required="true"
                    isString
                    list={{ list: coordenadores, value: 'id', label: 'nome' }}
                    name="idCoordenador"
                    firstOption
                    defaultValue={mountedData?.idCoordenador}
                  />
                </Label>
                <Label title="Coordenador Tec*" className="col s6 m4 l2">
                  <Select
                    required="true"
                    isString
                    list={{ list: coordenadores, value: 'id', label: 'nome' }}
                    name="idCoordenadorTec"
                    firstOption
                    defaultValue={mountedData?.idCoordenadorTec}
                  />
                </Label>
              </div>
              <div className="row no-margin">
                <Label title="Anexo 1" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo1"
                    defaultFile={mountedData?.anexo1}
                    formFile={setFile1}
                  />
                </Label>
                <Label title="Anexo 2" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo2"
                    defaultFile={mountedData?.anexo2}
                    formFile={setFile2}
                  />
                </Label>
                <Label title="Anexo 3" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo3"
                    defaultFile={mountedData?.anexo3}
                    formFile={setFile3}
                  />
                </Label>
                <Label title="Anexo 4" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo4"
                    defaultFile={mountedData?.anexo4}
                    formFile={setFile4}
                  />
                </Label>
              </div>
            </div>
          </div>
        ) : gerarProjeto ? (
          <div className="row">
            <div className="row no-margin">
              <Label title="Título *" className="col s12 m12 l4">
                <Input
                  name="titulo"
                  disabled="true"
                  required="true"
                  defaultValue={mountedData?.titulo}
                />
              </Label>
              <Label title="Data Solicitação *" className="col s6 m3 l2">
                <Input
                  type="date"
                  disabled="true"
                  name="dataSolicitacao"
                  required="true"
                  defaultValue={mountedData?.dataSolicitacao}
                />
              </Label>
              <Label title="Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                  name="idCliente"
                  disabled="true"
                  firstOption
                  defaultValue={mountedData?.idCliente}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    const cliente = clientes?.find(e => e?.id == parseInt(v));
                    setCliente(cliente || {});
                  }}
                />
              </Label>
              <Label title="Solicitante Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: solicitantes, value: 'id', label: 'nome' }}
                  name="idClienteSolicitante"
                  firstOption
                  defaultValue={mountedData?.idClienteSolicitante}
                />
              </Label>
              <Label title="Ativo *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'true', titulo: 'Sim' },
                      { id: 'false', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="ativo"
                  defaultValue={mountedData?.ativo?.toString()}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    setAtivo(v);
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Produto *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: produtos, value: 'id', label: 'titulo' }}
                  name="idProduto"
                  firstOption
                  defaultValue={mountedData?.idProduto}
                />
              </Label>
              <Label title="Coordenador *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenador"
                  firstOption
                  defaultValue={mountedData?.idCoordenador}
                />
              </Label>
              <Label title="Coordenador Tec*" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenadorTec"
                  firstOption
                  defaultValue={mountedData?.idCoordenadorTec}
                />
              </Label>
              <Label title="Hora Total *" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="horaTotal"
                  required="true"
                  disabled="true"
                  min="1"
                  value={horaTotal}
                />
              </Label>
              <Label title="Valor Hora" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorHora"
                  required="false"
                  defaultValue={mountedData?.valorHora}
                />
              </Label>
              <Label title="Valor Total *" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorTotal"
                  min="1"
                  required="true"
                  defaultValue={mountedData?.valorTotal}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Projeto Existente" className="col s6 m6 l2">
                <Select
                  isString
                  list={{ list: projetos, value: 'id', label: 'titulo' }}
                  name="idProjeto"
                  firstOption
                  defaultValue={mountedData?.idProjeto}
                />
              </Label>
              <Label title="Email Resp. Cliente *" className="col s6 m6 l2">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'S', titulo: 'Sim' },
                      { id: 'N', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="emailRespCliente"
                />
              </Label>
              <Label title="Data Inicio *" className="col s6 m6 l2">
                <Input type="date" name="dataInicioProjeto" required="true" />
              </Label>
              <Label title="Data Prev Entrega *" className="col s6 m6 l2">
                <Input type="date" name="dataPrevEntregaProjeto" required="true" />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Descrição da Solicitação" className="col s12 m12 l6">
                <TextArea
                  name="descricaoSolicitacao"
                  defaultValue={mountedData?.descricaoSolicitacao}
                />
              </Label>
              <div className="col s12 m12 l6">
                <RecursosList
                  setter={setRecursos}
                  defaultData={
                    typeof mountedData?.recurso == 'object'
                      ? mountedData?.recurso || []
                      : JSON.parse(mountedData?.recurso)
                  }
                />
              </div>
            </div>
            <div className="row no-margin">
              <Label title="Anexo 1" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo1"
                  defaultFile={mountedData?.anexo1}
                  formFile={setFile1}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 2" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo2"
                  defaultFile={mountedData?.anexo2}
                  formFile={setFile2}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 3" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo3"
                  defaultFile={mountedData?.anexo3}
                  formFile={setFile3}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 4" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo4"
                  defaultFile={mountedData?.anexo4}
                  formFile={setFile4}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <AtividadesList
                  setter={setAtividades}
                  defaultData={mountedData?.atividades || []}
                  setterSoma={setHoraTotal}
                />
              </div>
            </div>
          </div>
        ) : ultimaEtapa ? (
          <div className="row">
            <div className="row no-margin">
              <Label title="Título *" className="col s12 m12 l4">
                <Input
                  name="titulo"
                  disabled="true"
                  required="true"
                  defaultValue={mountedData?.titulo}
                />
              </Label>
              <Label title="Data Solicitação *" className="col s6 m3 l2">
                <Input
                  type="date"
                  disabled="true"
                  name="dataSolicitacao"
                  required="true"
                  defaultValue={mountedData?.dataSolicitacao}
                />
              </Label>
              <Label title="Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                  name="idCliente"
                  disabled="true"
                  firstOption
                  defaultValue={mountedData?.idCliente}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    const cliente = clientes?.find(e => e?.id == parseInt(v));
                    setCliente(cliente || {});
                  }}
                />
              </Label>
              <Label title="Solicitante Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: solicitantes, value: 'id', label: 'nome' }}
                  name="idClienteSolicitante"
                  firstOption
                  defaultValue={mountedData?.idClienteSolicitante}
                />
              </Label>
              <Label title="Ativo *" className="col s6 m3 l2">
                <Select
                  required="true"
                  disabled="true"
                  isString
                  list={{
                    list: [
                      { id: 'true', titulo: 'Sim' },
                      { id: 'false', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="ativo"
                  defaultValue={mountedData?.ativo?.toString()}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    setAtivo(v);
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Produto *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: produtos, value: 'id', label: 'titulo' }}
                  name="idProduto"
                  firstOption
                  defaultValue={mountedData?.idProduto}
                />
              </Label>
              <Label title="Coordenador *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenador"
                  firstOption
                  defaultValue={mountedData?.idCoordenador}
                />
              </Label>
              <Label title="Coordenador Tec*" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenadorTec"
                  firstOption
                  defaultValue={mountedData?.idCoordenadorTec}
                />
              </Label>
              <Label title="Hora Total *" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="horaTotal"
                  required="true"
                  disabled="true"
                  min="1"
                  value={horaTotal}
                />
              </Label>
              <Label title="Valor Hora" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorHora"
                  disabled="true"
                  step="0.10"
                  defaultValue={mountedData?.valorHora}
                />
              </Label>
              <Label title="Valor Total" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorTotal"
                  disabled="true"
                  step="0.10"
                  defaultValue={mountedData?.valorTotal}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Descrição da Solicitação" className="col s12 m12 l6">
                <TextArea
                  name="descricaoSolicitacao"
                  disabled="true"
                  defaultValue={mountedData?.descricaoSolicitacao}
                />
              </Label>
              <div className="col s12 m12 l6">
                <RecursosList
                  disabled="true"
                  setter={setRecursos}
                  defaultData={
                    typeof mountedData?.recurso == 'object'
                      ? mountedData?.recurso || []
                      : JSON.parse(mountedData?.recurso)
                  }
                />
              </div>
            </div>
            <div className="row no-margin">
              <Label title="Anexo 1" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo1"
                  disabled="true"
                  defaultFile={mountedData?.anexo1}
                  formFile={setFile1}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 2" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo2"
                  disabled="true"
                  defaultFile={mountedData?.anexo2}
                  formFile={setFile2}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 3" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo3"
                  disabled="true"
                  defaultFile={mountedData?.anexo3}
                  formFile={setFile3}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 4" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo4"
                  disabled="true"
                  defaultFile={mountedData?.anexo4}
                  formFile={setFile4}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <AtividadesList
                  disabled="true"
                  setter={setAtividades}
                  defaultData={mountedData?.atividades || []}
                  setterSoma={setHoraTotal}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="row no-margin">
              <Label title="Título *" className="col s12 m12 l4">
                <Input
                  name="titulo"
                  disabled="true"
                  required="true"
                  defaultValue={mountedData?.titulo}
                />
              </Label>
              <Label title="Data Solicitação *" className="col s6 m3 l2">
                <Input
                  type="date"
                  disabled="true"
                  name="dataSolicitacao"
                  required="true"
                  defaultValue={mountedData?.dataSolicitacao}
                />
              </Label>
              <Label title="Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                  name="idCliente"
                  disabled="true"
                  firstOption
                  defaultValue={mountedData?.idCliente}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    const cliente = clientes?.find(e => e?.id == parseInt(v));
                    setCliente(cliente || {});
                  }}
                />
              </Label>
              <Label title="Solicitante Cliente *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: solicitantes, value: 'id', label: 'nome' }}
                  name="idClienteSolicitante"
                  firstOption
                  defaultValue={mountedData?.idClienteSolicitante}
                />
              </Label>
              <Label title="Ativo *" className="col s6 m3 l2">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'true', titulo: 'Sim' },
                      { id: 'false', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="ativo"
                  defaultValue={mountedData?.ativo?.toString()}
                  onChange={e => {
                    const v = e.currentTarget.value || 'true';
                    setAtivo(v);
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Produto *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  disabled="true"
                  list={{ list: produtos, value: 'id', label: 'titulo' }}
                  name="idProduto"
                  firstOption
                  defaultValue={mountedData?.idProduto}
                />
              </Label>
              <Label title="Coordenador *" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenador"
                  firstOption
                  defaultValue={mountedData?.idCoordenador}
                />
              </Label>
              <Label title="Coordenador Tec*" className="col s6 m4 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: coordenadores, value: 'id', label: 'nome' }}
                  name="idCoordenadorTec"
                  firstOption
                  defaultValue={mountedData?.idCoordenadorTec}
                />
              </Label>
              <Label title="Hora Total *" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="horaTotal"
                  required="true"
                  disabled="true"
                  min="1"
                  value={horaTotal}
                />
              </Label>
              <Label title="Valor Hora" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorHora"
                  step="0.10"
                  defaultValue={mountedData?.valorHora}
                />
              </Label>
              <Label title="Valor Total *" className="col s6 m4 l2">
                <Input
                  type="number"
                  name="valorTotal"
                  required="true"
                  step="0.10"
                  defaultValue={mountedData?.valorTotal}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Descrição da Solicitação" className="col s12 m12 l6">
                <TextArea
                  name="descricaoSolicitacao"
                  defaultValue={mountedData?.descricaoSolicitacao}
                />
              </Label>
              <div className="col s12 m12 l6">
                <RecursosList
                  setter={setRecursos}
                  defaultData={
                    typeof mountedData?.recurso == 'object'
                      ? mountedData?.recurso || []
                      : JSON.parse(mountedData?.recurso)
                  }
                />
              </div>
            </div>
            <div className="row no-margin">
              <Label title="Anexo 1" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo1"
                  defaultFile={mountedData?.anexo1}
                  formFile={setFile1}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 2" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo2"
                  defaultFile={mountedData?.anexo2}
                  formFile={setFile2}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 3" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo3"
                  defaultFile={mountedData?.anexo3}
                  formFile={setFile3}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
              <Label title="Anexo 4" className="col s12 m6 l3">
                <ColoredFileInput
                  name="anexo4"
                  defaultFile={mountedData?.anexo4}
                  formFile={setFile4}
                  onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <AtividadesList
                  setter={setAtividades}
                  defaultData={mountedData?.atividades || []}
                  setterSoma={setHoraTotal}
                />
              </div>
            </div>
          </div>
        )}
      </Materialize>
      <div className="footer">
        <Label title="Etapa *" className="no-margin" row={true}>
          <Select
            required="true"
            {...{ ...(ultimaEtapa ? { disabled: 'true' } : {}) }}
            isString
            list={{ list: etapas, value: 'id', label: 'titulo' }}
            name="idEtapa"
            defaultValue={idEtapa}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setIdEtapa(parseInt(v));

              const item = etapas.find(data => data?.id === parseInt(v));
              setGerarProjeto(item?.final == 'S' ? true : false);
            }}
          />
        </Label>
        <PrioridadeListColor
          name="idPrioridade"
          {...{ ...(ultimaEtapa ? { disabled: 'true' } : {}) }}
          setter={setPrioridade}
          defaultData={mountedData?.prioridade}
        />
      </div>
    </Container>
  );
}

export default CreateEditContent;
